var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 63,
    viewBox: "0 0 65 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7066 20.7899C53.7391 21.2527 53.7391 21.7156 53.7391 22.1827C53.7391 36.4151 42.7323 52.8295 22.6058 52.8295V52.821C16.6604 52.8295 10.8385 51.1531 5.83337 47.9922C6.69789 48.0946 7.56673 48.1458 8.43775 48.1479C13.3648 48.1522 18.1511 46.5248 22.0273 43.5282C17.3451 43.4407 13.2392 40.4356 11.8048 36.0483C13.445 36.3597 15.135 36.2957 16.7449 35.8627C11.6401 34.8475 7.96757 30.4325 7.96757 25.3052C7.96757 25.2582 7.96757 25.2134 7.96757 25.1687C9.4886 26.0026 11.1916 26.4654 12.9337 26.5166C8.12574 23.3536 6.64372 17.0574 9.5471 12.1348C15.1025 18.864 23.2991 22.9548 32.0981 23.3877C31.2163 19.6467 32.421 15.7265 35.2637 13.0967C39.6707 9.01874 46.602 9.22776 50.7447 13.5638C53.1953 13.0882 55.544 12.2031 57.6934 10.949C56.8765 13.4423 55.167 15.5602 52.8833 16.906C55.0521 16.6543 57.1712 16.0827 59.1667 15.2104C57.6977 17.3774 55.8473 19.2649 53.7066 20.7899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.534aa5fc6838a7dc55ead4d61b2867ca.svg";
export { ForwardRef as ReactComponent };